import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/icons/icons.css';
import 'react-quill/dist/quill.snow.css'; // ES6
import './assets/autoSuggest.css';
import 'react-fine-uploader/gallery/gallery.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js